// Tabs. Controlled like MUI: value + onChange(event, newValue); tabs = [{ value, label, disabled }].
import { cn } from "./cn";

export function Tabs({ value, onChange, tabs = [], className }) {
  return (
    <div role="tablist" className={cn("flex gap-1 overflow-x-auto border-b border-line", className)}>
      {tabs.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={t.disabled}
            onClick={(e) => onChange?.(e, t.value)}
            className={cn(
              "-mb-px h-10 shrink-0 border-b-2 px-3 text-[13px] font-medium whitespace-nowrap transition-colors disabled:opacity-40",
              active ? "border-accent text-fg" : "border-transparent text-muted hover:text-fg",
            )}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
